import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'if_the_fac_has_overdue_social_insurance_social_security_debts_d'

export const dataPointDefinition = {
  retracedId: 'if_the_fac_has_overdue_social_insurance_social_security_debts_d',
  name: 'If the facility has overdue social insurance / social security debts due to non-payment or untimely payment of contributions, is the facility actively correcting this legal non-compliance?',
  description:
    '"Actively correcting" means there is a valid agreement in place to address the overdue debts, and the facility is implementing the agreement correctly, i.e., the facility is following the valid agreement. \r\r\n\r\r\nIf the facility has overdue debts and no agreement or no valid agreement in place, answer No. \r\r\n\r\r\nIf the facility has overdue debts and an agreement is in place but the facility is not following the agreement, answer No. \r\r\n\r\r\nIf the facility has no overdue social insurance / social security debts, answer Not Applicable.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wage-90',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 9380,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
